import { Mic, MicOff, Send, Loader2, Square } from "lucide-react";
import { bumpOrb, setOrbState, orbStore, useOrbState } from "@/lib/orb";

const placeholderFor = (disabled, dictating) => {
  if (disabled) return "Abbonamento scaduto";
  return dictating ? "Ti ascolto… parla ora" : "Scrivi qui la tua domanda…";
};

export const CommandBar = ({ value, onChange, onSend, busy, onStop, dictating, onDictate, disabled }) => {
  const orb = useOrbState();
  const type = (e) => {
    onChange(e.target.value);
    bumpOrb(0.35);
    if (orbStore.state === "idle" || orbStore.state === "ascolto") {
      setOrbState("ascolto");
      clearTimeout(window.__auroraTypeT);
      window.__auroraTypeT = setTimeout(() => orbStore.state === "ascolto" && !dictating && setOrbState("idle"), 900);
    }
  };
  const glow = { ascolto: "shadow-[0_0_36px_rgba(34,211,238,.45)] border-cyan-400/60", elaborazione: "shadow-[0_0_36px_rgba(139,92,246,.5)] border-violet-400/60", parlato: "shadow-[0_0_40px_rgba(251,191,36,.45)] border-amber-300/60" }[orb] || "shadow-[0_0_30px_rgba(6,182,212,.2)] border-cyan-500/30";
  const iconBtn = "shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-[background-color,color,transform] duration-200 active:scale-95";

  return (
    <div data-testid="command-bar" className={`backdrop-blur-2xl bg-[#0a1224]/90 border rounded-2xl p-2 sm:p-2.5 transition-[box-shadow,border-color] duration-500 ${glow}`}>
      <div className="flex items-center gap-1.5 sm:gap-2">
        <textarea
          data-testid="command-bar-input" rows={1} value={value} onChange={type} disabled={disabled}
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); } }}
          placeholder={placeholderFor(disabled, dictating)}
          className="flex-1 min-w-0 resize-none bg-transparent outline-none text-sm sm:text-base text-slate-100 placeholder:text-slate-500 py-2.5 px-2 max-h-32"
        />
        <button onClick={onDictate} disabled={disabled} title="Dettatura" data-testid="btn-command-mic"
          className={`${iconBtn} ${dictating ? "bg-cyan-400 text-[#031018]" : "text-cyan-300 hover:bg-cyan-500/15"} disabled:opacity-40`}>
          {dictating ? <MicOff size={18} /> : <Mic size={18} />}
        </button>
        {busy ? (
          <button onClick={onStop} data-testid="btn-command-stop" className={`${iconBtn} bg-violet-500/80 text-white`}><Square size={16} /></button>
        ) : (
          <button onClick={onSend} disabled={disabled || !value.trim()} data-testid="btn-command-send" className={`${iconBtn} btn-aurora disabled:opacity-40`}>
            {dictating ? <Loader2 size={18} className="animate-spin" /> : <Send size={17} />}
          </button>
        )}
      </div>
    </div>
  );
};
